<template>
  <b-card>
    <FormBuilder
      label="Voucher"
      update
      :data="$store.state.voucherV2.detailData"
      :fields="fields"
      :loading-detail="$store.state.voucherV2.loadingDetail"
      :loading-submit="$store.state.voucherV2.loadingSubmit"
      @load="loadData"
      @submit="submitData"
      @reset="resetData"
    />
  </b-card>
</template>

<script>
import FormBuilder from '@/layouts/components/v2/FormBuilder.vue'

import {
  BCard,
} from 'bootstrap-vue'

import fields from '@/field/form/voucher'

export default {
  components: {
    BCard,
    FormBuilder,
  },
  setup() {
    return {
      fields,
    }
  },
  methods: {
    loadData(id) {
      return this.$store.dispatch('voucherV2/getDetail', id)
    },
    submitData(id, data, callback) {
      this.$store.dispatch('voucherV2/update', { id, data })
        .then(() => {
          if (typeof callback === 'function') callback()
        })
        .catch(err => callback(err))
    },
    resetData() {
      return this.$store.commit('voucherV2/SET_DETAIL_DATA', undefined)
    },
  },
}
</script>

<style scoped>

</style>
